import PostulantLoader from '../../loaders/PostulantLoader';
import StudentTabsHeader from '../StudentTabsHeader';
import PostulantUpdateForm from './parts/PostulantUpdateForm';

export default function StudentPersonalInformation() {
  return (
    <PostulantLoader>
      {(props) => (
        <>
          <StudentTabsHeader
            name={props?.postulant?.fullName}
            id={props?.postulant?.rut}
          />
          <PostulantUpdateForm
            defaultValues={props?.defaultValues}
            photo={props?.photo}
          />
        </>
      )}
    </PostulantLoader>
  );
}
